import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, ChefHat, Users, CalendarDays, Gift, Bot, Mail, QrCode, CircleDot,
  UtensilsCrossed, Receipt, Brain, Lock, Euro, PenLine, Wallet, Calculator,
  TrendingUp, BookOpen, Snowflake, ClipboardList, Contact, Target, Search, Zap, Clock,
  CheckSquare, PieChart, Landmark, Wrench, Trash2, Palmtree, Settings, UserCog, Send,
  Globe, FileText, BarChart3, Shield, ExternalLink, CreditCard, ClipboardCheck,
  Utensils, Truck, Sparkles, ArrowRight, ChevronRight, LogOut, Eye, EyeOff
} from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const APPS = [
  {
    category: 'Pilotage',
    items: [
      { id: 'patron', icon: LayoutDashboard, label: 'Tableau de bord', desc: 'Vue d\'ensemble mensuelle', path: '/patron', tab: 'dashboard' },
      { id: 'ratios', icon: PieChart, label: 'Ratios Cles', desc: 'Food cost, salaires, loyer', path: '/patron', tab: 'ratios' },
      { id: 'taches', icon: CheckSquare, label: 'Taches & Planning', desc: 'Calendrier, rappels', path: '/patron', tab: 'taches' },
      { id: 'tresorerie', icon: Wallet, label: 'Tresorerie', desc: 'Suivi bancaire & flux', path: '/patron', tab: 'tresorerie' },
      { id: 'budget', icon: Calculator, label: 'Budget', desc: 'Budget mensuel', path: '/patron', tab: 'budget' },
      { id: 'previsionnel', icon: TrendingUp, label: 'Previsionnel', desc: 'Projections & objectifs', path: '/patron', tab: 'previsionnel' },
    ]
  },
  {
    category: 'Activite',
    items: [
      { id: 'ca', icon: Euro, label: 'Chiffre d\'affaires', desc: 'CA en temps reel', path: '/patron', tab: 'ca' },
      { id: 'saisie', icon: PenLine, label: 'Saisie CA', desc: 'Saisie quotidienne', path: '/patron', tab: 'saisie' },
      { id: 'suivi', icon: CalendarDays, label: 'Bilan annuel', desc: 'Historique & tendances', path: '/patron', tab: 'suivi' },
      { id: 'factures', icon: Receipt, label: 'Factures & OCR', desc: 'Scan, suivi fournisseurs', path: '/patron', tab: 'factures' },
    ]
  },
  {
    category: 'Restaurant',
    items: [
      { id: 'menu-du-jour', icon: CalendarDays, label: 'Menu du Jour', desc: 'Hebdomadaire & programmation', path: '/patron', tab: 'menu-du-jour' },
      { id: 'carte', icon: BookOpen, label: 'Carte & Menu', desc: 'Gestion de la carte', path: '/patron', tab: 'menu' },
      { id: 'food-cost', icon: UtensilsCrossed, label: 'Food Cost', desc: 'Cout des plats', path: '/patron', tab: 'carte' },
      { id: 'mercuriales', icon: ClipboardList, label: 'Mercuriales', desc: 'Prix fournisseurs', path: '/patron', tab: 'mercuriales' },
      { id: 'traiteur', icon: ChefHat, label: 'Traiteur', desc: 'Activite traiteur', path: '/patron', tab: 'traiteur' },
      { id: 'congelateur', icon: Snowflake, label: 'Congelateur', desc: 'Stock congeles', path: '/patron', tab: 'congelateur' },
    ]
  },
  {
    category: 'Commercial',
    items: [
      { id: 'reservations', icon: CalendarDays, label: 'Reservations', desc: 'Gestion des resas', path: '/patron', tab: 'reservations' },
      { id: 'resa-calendar', icon: CalendarDays, label: 'Calendrier', desc: 'Planning visuel', path: '/patron', tab: 'resa-calendar' },
      { id: 'clients', icon: Contact, label: 'Clients', desc: 'Base clients & fidelite', path: '/patron', tab: 'clients' },
      { id: 'bons', icon: Gift, label: 'Bons Cadeaux', desc: 'Vente en ligne Stripe', path: '/patron', tab: 'bons-cadeaux' },
      { id: 'roue', icon: CircleDot, label: 'Roue du Mas', desc: 'Jeu de fidelite', path: '/roue', external: true },
    ]
  },
  {
    category: 'Prospection B2B',
    items: [
      { id: 'crm-campagne', icon: Send, label: 'Mes Campagnes', desc: 'Envoi & suivi emails', path: '/patron', tab: 'crm-campagne' },
      { id: 'email-templates', icon: FileText, label: 'Templates Email', desc: 'B2B / B2C / Saisons', path: '/patron', tab: 'email-templates' },
      { id: 'crm-pipeline', icon: Contact, label: 'Mes Prospects', desc: '193 entreprises', path: '/patron', tab: 'crm-pipeline' },
      { id: 'crm-relances', icon: Clock, label: 'Relances', desc: 'A rappeler / suivi auto', path: '/patron', tab: 'crm-relances' },
    ]
  },
  {
    category: 'Propositions',
    items: [
      { id: 'prop-dashboard', icon: FileText, label: 'Suivi Commercial', desc: 'Devis & propositions', path: '/patron', tab: 'prop-dashboard' },
      { id: 'rdv-commercial', icon: ClipboardList, label: 'RDV Commercial', desc: 'Premier contact guide', path: '/patron', tab: 'rdv-commercial' },
      { id: 'prop-pipeline', icon: Target, label: 'Pipeline', desc: 'Kanban propositions', path: '/patron', tab: 'prop-pipeline' },
    ]
  },
  {
    category: 'Gestion',
    items: [
      { id: 'salaires', icon: Users, label: 'Salaires', desc: 'Masse salariale', path: '/patron', tab: 'salaires' },
      { id: 'conges', icon: Palmtree, label: 'Conges', desc: 'Planning conges', path: '/patron', tab: 'conges' },
      { id: 'fixes', icon: Wrench, label: 'Charges fixes', desc: 'Loyer, assurances...', path: '/patron', tab: 'fixes' },
      { id: 'pertes', icon: Trash2, label: 'Pertes', desc: 'Suivi des pertes', path: '/patron', tab: 'pertes' },
      { id: 'banques', icon: Landmark, label: 'Banques', desc: 'Comptes bancaires', path: '/patron', tab: 'banques' },
      { id: 'rapprochement', icon: PieChart, label: 'Rapprochement', desc: 'Rapprochement bancaire', path: '/patron', tab: 'rapprochement' },
    ]
  },
  {
    category: 'Outils & IA',
    items: [
      { id: 'ia-cowork', icon: Bot, label: 'IA Cowork', desc: 'Assistant IA personnel', path: '/patron', tab: 'ia-cowork' },
      { id: 'messagerie', icon: Mail, label: 'Messagerie', desc: 'Emails IMAP/SMTP', path: '/patron', tab: 'messagerie' },
      { id: 'admin-site', icon: Globe, label: 'Site Web', desc: 'Gestion du site public', path: '/patron', tab: 'admin-site' },
      { id: 'optimisation', icon: Brain, label: 'Optim IA', desc: 'Analyse & conseils IA', path: '/patron', tab: 'optimisation' },
      { id: 'telegram', icon: Send, label: 'Telegram', desc: 'Bots & notifications', path: '/patron', tab: 'telegram' },
      { id: 'whatsapp', icon: Bot, label: 'WhatsApp', desc: 'Conversations clients IA', path: '/patron', tab: 'whatsapp' },
      { id: 'users', icon: UserCog, label: 'Acces', desc: 'Utilisateurs & roles', path: '/patron', tab: 'users' },
    ]
  },
  {
    category: 'Equipe',
    items: [
      { id: 'portal-chef', icon: ChefHat, label: 'Espace Chef', desc: 'Cuisine, recettes, couts', path: '/chef', locked: true },
      { id: 'portal-responsable', icon: Shield, label: 'Chef de Salle', desc: 'Bons cadeaux, scan', path: '/responsable', locked: true },
      { id: 'portal-employe', icon: Users, label: 'Employe', desc: 'Reservations, planning', path: '/employe', locked: true },
      { id: 'scanner', icon: QrCode, label: 'Scanner QR', desc: 'Scan bons + fidelite', path: '/scan' },
    ]
  },
  {
    category: 'Site Web Public',
    items: [
      { id: 'site-resto', icon: Utensils, label: 'Site Restaurant', desc: 'Vitrine publique', path: '/site/restaurant', external: true },
      { id: 'site-traiteur', icon: Truck, label: 'Site Traiteur', desc: 'Vitrine publique', path: '/site/traiteur', external: true },
    ]
  },
  {
    category: 'A venir',
    items: [
      { id: 'caisse', icon: CreditCard, label: 'Caisse / Pointeuse', desc: 'Integration systeme de caisse', path: null, badge: 'Bientot' },
      { id: 'hygiene', icon: ClipboardCheck, label: 'Hygiene HACCP', desc: 'Normes hygiene & tracabilite', path: null, badge: 'Bientot' },
    ]
  },
];

export default function AdminHub() {
  const nav = useNavigate();
  const [authenticated, setAuthenticated] = useState(false);
  const [checking, setChecking] = useState(true);
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [loginError, setLoginError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);
  const [todayTasks, setTodayTasks] = useState([]);
  const [overdue, setOverdue] = useState([]);
  const [activeCampaign, setActiveCampaign] = useState(null);

  // Check auth on mount
  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (!token) { setChecking(false); return; }
    fetch(`${API}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(data => {
        if (data.role === 'patron') { setAuthenticated(true); }
        else { setLoginError('Acces reserve au patron'); }
      })
      .catch(() => { localStorage.removeItem('auth_token'); })
      .finally(() => setChecking(false));
  }, []);

  // Load tasks once authenticated
  useEffect(() => {
    if (!authenticated) return;
    const today = new Date().toISOString().split('T')[0];
    const month = today.slice(0, 7);
    const token = localStorage.getItem('auth_token');
    fetch(`${API}/api/tasks?month=${month}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(data => {
        if (Array.isArray(data)) {
          const pending = data.filter(t => !t.completed);
          const pMap = { haute: 0, moyenne: 1, basse: 2 };
          setTodayTasks(pending.filter(t => t.date === today).sort((a, b) => (pMap[a.priority] || 1) - (pMap[b.priority] || 1)));
          setOverdue(pending.filter(t => t.date < today).sort((a, b) => a.date.localeCompare(b.date)));
        }
      }).catch(() => {});

    // Load active CRM email campaign and refresh every 30s
    const loadActiveCampaign = async () => {
      try {
        const r = await fetch(`${API}/api/crm/campagnes-email`);
        const list = await r.json();
        if (!Array.isArray(list) || list.length === 0) { setActiveCampaign(null); return; }
        const active = list.find(c => c.status === 'active');
        if (!active) { setActiveCampaign(null); return; }
        const dr = await fetch(`${API}/api/crm/campagne-email/${active.id}`);
        setActiveCampaign(await dr.json());
      } catch {}
    };
    loadActiveCampaign();
    const cid = setInterval(loadActiveCampaign, 30000);
    return () => clearInterval(cid);
  }, [authenticated]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    setLoginError('');
    try {
      const res = await fetch(`${API}/api/auth/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: loginForm.email.trim().toLowerCase(), password: loginForm.password }),
      });
      const data = await res.json();
      if (!res.ok) { setLoginError(data.detail || 'Identifiants incorrects'); setLoginLoading(false); return; }
      if (data.user?.role !== 'patron') { setLoginError('Acces reserve au patron'); setLoginLoading(false); return; }
      localStorage.setItem('auth_token', data.token);
      sessionStorage.setItem('patron_auth', 'true');
      sessionStorage.setItem('user_role', data.user.role);
      sessionStorage.setItem('user_email', data.user.email);
      setAuthenticated(true);
    } catch { setLoginError('Erreur de connexion'); }
    setLoginLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    sessionStorage.removeItem('patron_auth');
    sessionStorage.removeItem('user_role');
    sessionStorage.removeItem('user_email');
    setAuthenticated(false);
    setLoginForm({ email: '', password: '' });
  };

  const handleClick = (app) => {
    if (!app.path) return;
    if (app.external) {
      if (app.path.startsWith('http')) { window.open(app.path, '_blank'); }
      else { nav(app.path); }
      return;
    }
    if (app.tab) sessionStorage.setItem('patron_tab', app.tab);
    nav(app.path);
  };

  const priColor = (p) => p === 'haute' ? '#ef4444' : p === 'basse' ? '#22c55e' : '#f59e0b';
  const hasAgenda = todayTasks.length > 0 || overdue.length > 0;

  const joursFR = ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'];
  const moisFR = ['janvier','fevrier','mars','avril','mai','juin','juillet','aout','septembre','octobre','novembre','decembre'];
  const now = new Date();
  const dateLabel = `${joursFR[now.getDay()]} ${now.getDate()} ${moisFR[now.getMonth()]}`;

  // Loading spinner
  if (checking) {
    return (
      <div className="min-h-screen bg-[#F8F7F4] flex items-center justify-center">
        <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600;700&family=Manrope:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
        <div className="animate-spin w-8 h-8 border-2 border-[#1a2744] border-t-transparent rounded-full" />
      </div>
    );
  }

  // Login screen
  if (!authenticated) {
    return (
      <div className="min-h-screen bg-[#1a2744] flex items-center justify-center px-4" data-testid="hub-login">
        <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Manrope:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
        <div className="w-full max-w-sm">
          <div className="text-center mb-8">
            <img src="/images/logo-restaurant.jpg" alt="Le Mas" className="h-16 rounded-xl mx-auto mb-4 shadow-lg" />
            <h1 className="text-3xl text-white tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>Le Mas</h1>
            <p className="text-white/30 text-xs mt-1 uppercase tracking-[0.2em]" style={{ fontFamily: "'Manrope', sans-serif" }}>Centre de gestion</p>
          </div>
          <form onSubmit={handleLogin} className="space-y-3">
            <div>
              <label className="text-[10px] text-white/40 uppercase tracking-wider block mb-1" style={{ fontFamily: "'Manrope', sans-serif" }}>Email</label>
              <div className="relative">
                <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/20" />
                <input type="email" value={loginForm.email} onChange={e => setLoginForm(f => ({ ...f, email: e.target.value }))}
                  placeholder="patron@lemas.fr" required autoComplete="email"
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 pl-9 text-white text-sm placeholder:text-white/20 outline-none focus:border-white/30 transition-colors"
                  style={{ fontFamily: "'Manrope', sans-serif" }} data-testid="hub-login-email" />
              </div>
            </div>
            <div>
              <label className="text-[10px] text-white/40 uppercase tracking-wider block mb-1" style={{ fontFamily: "'Manrope', sans-serif" }}>Mot de passe</label>
              <div className="relative">
                <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/20" />
                <input type={showPw ? 'text' : 'password'} value={loginForm.password} onChange={e => setLoginForm(f => ({ ...f, password: e.target.value }))}
                  placeholder="••••••••" required autoComplete="current-password"
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 pl-9 pr-10 text-white text-sm placeholder:text-white/20 outline-none focus:border-white/30 transition-colors"
                  style={{ fontFamily: "'Manrope', sans-serif" }} data-testid="hub-login-password" />
                <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/20 hover:text-white/40">
                  {showPw ? <EyeOff size={14} /> : <Eye size={14} />}
                </button>
              </div>
            </div>
            {loginError && (
              <div className="bg-red-500/10 border border-red-500/20 rounded-xl px-3 py-2" data-testid="hub-login-error">
                <p className="text-red-400 text-xs" style={{ fontFamily: "'Manrope', sans-serif" }}>{loginError}</p>
              </div>
            )}
            <button type="submit" disabled={loginLoading}
              className="w-full py-3 rounded-xl bg-white text-[#1a2744] font-bold text-sm hover:bg-white/90 transition-colors disabled:opacity-50 mt-2"
              style={{ fontFamily: "'Manrope', sans-serif" }} data-testid="hub-login-submit">
              {loginLoading ? 'Connexion...' : 'Connexion'}
            </button>
          </form>
          <p className="text-center text-white/20 text-[10px] mt-8" style={{ fontFamily: "'Manrope', sans-serif" }}>
            Saint-Laurent-de-la-Salanque &middot; 04 68 38 06 98
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F8F7F4]" data-testid="admin-hub">
      <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Manrope:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

      {/* Sticky Header */}
      <header className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-2xl border-b border-[#E5E7EB]" style={{ WebkitBackdropFilter: 'blur(24px) saturate(1.5)' }}>
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16 sm:h-20 px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3">
            <img src="/images/logo-restaurant.jpg" alt="Le Mas" className="h-9 sm:h-11 rounded-lg" />
            <h1 className="text-xl sm:text-2xl text-[#111827] tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
              Le Mas
            </h1>
          </div>
        <div className="flex items-center gap-3">
          <span className="text-[10px] sm:text-xs uppercase tracking-[0.15em] text-[#6B7280]" style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 700 }}>
            Centre de gestion
          </span>
          <button onClick={handleLogout}
            className="p-2 rounded-lg hover:bg-gray-100 text-[#9CA3AF] hover:text-red-400 transition-colors"
            title="Deconnexion" data-testid="hub-logout">
            <LogOut size={16} />
          </button>
        </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 pt-2">

        {/* Agenda du jour — Dark Hero Widget */}
        {hasAgenda && (
          <div className="w-full bg-[#111827] rounded-2xl sm:rounded-3xl p-6 sm:p-8 mt-6 sm:mt-8 mb-10 relative overflow-hidden"
            style={{ boxShadow: '0 8px 30px rgba(17,24,39,0.12)' }} data-testid="hub-agenda">
            {/* Subtle noise pattern */}
            <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.65\' numOctaves=\'3\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\'/%3E%3C/svg%3E")' }} />
            <div className="relative z-10">
              <div className="flex items-center justify-between mb-5">
                <div>
                  <h2 className="text-2xl sm:text-3xl text-white tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
                    Agenda du jour
                  </h2>
                  <p className="text-[#9CA3AF] text-xs mt-1" style={{ fontFamily: "'Manrope', sans-serif" }}>{dateLabel}</p>
                </div>
                <button onClick={() => { sessionStorage.setItem('patron_tab', 'taches'); nav('/patron'); }}
                  className="flex items-center gap-1 text-[#9CA3AF] hover:text-white text-xs transition-colors" style={{ fontFamily: "'Manrope', sans-serif" }}
                  data-testid="hub-goto-tasks">
                  Voir tout <ChevronRight size={14} />
                </button>
              </div>
              <div className="flex flex-wrap gap-2">
                {overdue.slice(0, 4).map(t => (
                  <span key={t.id} className="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-red-500/10 border border-red-500/20 text-[11px]"
                    style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 600 }} data-testid={`hub-task-${t.id}`}>
                    <span className="w-2 h-2 rounded-full bg-red-400 animate-pulse shrink-0" />
                    <span className="text-red-300 truncate max-w-[160px]">{t.title}</span>
                    <span className="text-red-500/50 text-[9px]">retard</span>
                  </span>
                ))}
                {todayTasks.map(t => (
                  <span key={t.id} className="inline-flex items-center gap-2 px-3 py-2 rounded-xl border text-[11px]"
                    style={{
                      fontFamily: "'Manrope', sans-serif", fontWeight: 600,
                      backgroundColor: priColor(t.priority) + '10',
                      borderColor: priColor(t.priority) + '30',
                      color: priColor(t.priority),
                    }} data-testid={`hub-task-${t.id}`}>
                    <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: priColor(t.priority) }} />
                    <span className="truncate max-w-[160px]">{t.time ? `${t.time} ` : ''}{t.title}</span>
                  </span>
                ))}
                {overdue.length > 4 && <span className="text-[#9CA3AF] text-[10px] self-center ml-1">+{overdue.length - 4} en retard</span>}
              </div>
            </div>
          </div>
        )}

        {/* Active CRM Email Campaign — Live Status */}
        {activeCampaign && (() => {
          const stats = activeCampaign.stats || {};
          const sent = stats.envoye || 0;
          const programmed = stats.programme || 0;
          const errored = stats.erreur || 0;
          const cancelled = stats.annule || 0;
          const total = sent + programmed + errored + cancelled;
          const pct = total > 0 ? Math.round((sent / total) * 100) : 0;
          // Find next email to send
          const nextEmail = (activeCampaign.emails || []).filter(e => e.status === 'programme').sort((a, b) => (a.send_at || '').localeCompare(b.send_at || ''))[0];
          return (
            <div className="w-full bg-white rounded-2xl sm:rounded-3xl p-5 sm:p-6 mb-10 border border-[#E5E7EB] hover:shadow-lg transition-shadow"
              style={{ boxShadow: '0 4px 20px rgba(124,58,237,0.08)' }} data-testid="hub-active-campaign">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#7C3AED] to-[#A855F7] flex items-center justify-center shrink-0">
                    <Send size={18} className="text-white" />
                  </div>
                  <div className="min-w-0">
                    <h2 className="text-base sm:text-lg text-[#111827] tracking-tight truncate" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}>
                      Campagne email en cours
                    </h2>
                    <p className="text-[11px] text-[#6B7280] truncate" style={{ fontFamily: "'Manrope', sans-serif" }}>{activeCampaign.subject}</p>
                  </div>
                </div>
                <button onClick={() => { sessionStorage.setItem('patron_tab', 'crm-campagne'); nav('/patron'); }}
                  className="flex items-center gap-1 text-[#7C3AED] hover:text-[#A855F7] text-xs font-semibold transition-colors shrink-0"
                  style={{ fontFamily: "'Manrope', sans-serif" }}
                  data-testid="hub-goto-campagne">
                  Voir détail <ChevronRight size={14} />
                </button>
              </div>
              <div className="flex items-center justify-between text-xs mb-2" style={{ fontFamily: "'Manrope', sans-serif" }}>
                <span className="font-bold text-[#111827]">{sent} / {total} envoyés</span>
                <span className="text-[#7C3AED] font-bold">{pct}%</span>
              </div>
              <div className="h-2 bg-purple-100 rounded-full overflow-hidden mb-3">
                <div className="h-full bg-gradient-to-r from-[#7C3AED] to-[#A855F7] transition-all duration-500" style={{ width: `${pct}%` }} />
              </div>
              <div className="flex gap-2 flex-wrap items-center text-[10px]" style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 600 }}>
                {sent > 0 && <span className="px-2.5 py-1 rounded-full bg-green-50 text-green-700 border border-green-100">✓ {sent} envoyé{sent > 1 ? 's' : ''}</span>}
                {programmed > 0 && <span className="px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 border border-blue-100">⏳ {programmed} en attente</span>}
                {errored > 0 && <span className="px-2.5 py-1 rounded-full bg-red-50 text-red-700 border border-red-100">✗ {errored} erreur{errored > 1 ? 's' : ''}</span>}
                {nextEmail && (
                  <span className="ml-auto text-[#6B7280]">
                    Prochain : <span className="text-[#111827] font-semibold">{nextEmail.prospect_nom}</span> à {new Date(nextEmail.send_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                  </span>
                )}
              </div>
            </div>
          );
        })()}

        {/* App Sections */}
        {APPS.map((section, si) => (
          <div key={section.category} className={hasAgenda && si === 0 ? '' : si === 0 ? 'mt-8' : 'mt-12 sm:mt-16'} data-testid={`section-${section.category.toLowerCase().replace(/\s/g, '-')}`}>
            <h2 className="text-xl sm:text-2xl tracking-tight text-[#111827] mb-4 sm:mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}>
              {section.category}
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 sm:gap-4">
              {section.items.map((app) => {
                const Icon = app.icon;
                const disabled = !app.path;
                return (
                  <button key={app.id}
                    onClick={() => handleClick(app)}
                    disabled={disabled}
                    className={`group relative flex flex-col justify-between bg-white rounded-2xl border border-[#E5E7EB] p-4 sm:p-5 h-[130px] sm:h-[150px] overflow-hidden text-left
                      ${disabled
                        ? 'opacity-50 cursor-not-allowed grayscale-[50%]'
                        : 'hover:-translate-y-1 hover:shadow-[0_12px_24px_rgba(0,0,0,0.06)] hover:border-[#D1D5DB] active:scale-[0.98]'
                      }`}
                    style={{ transition: 'all 300ms cubic-bezier(0.25,1,0.5,1)', boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}
                    data-testid={`app-tile-${app.id}`}
                  >
                    {/* Top row */}
                    <div className="flex items-start justify-between w-full mb-3">
                      <div className="p-2 rounded-xl bg-[#F8F7F4] text-[#111827] group-hover:bg-[#111827] group-hover:text-white"
                        style={{ transition: 'all 300ms cubic-bezier(0.25,1,0.5,1)' }}>
                        <Icon size={20} strokeWidth={1.5} />
                      </div>
                      {app.badge && (
                        <span className="px-2 py-0.5 rounded-full bg-[#F3F4F6] text-[#4B5563] text-[9px] uppercase tracking-wider"
                          style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 700 }}>
                          {app.badge}
                        </span>
                      )}
                      {app.external && !app.badge && (
                        <ExternalLink size={14} className="text-[#D1D5DB] group-hover:text-[#6B7280] transition-colors" />
                      )}
                      {app.locked && !app.badge && (
                        <Lock size={14} className="text-[#D1D5DB]" />
                      )}
                    </div>
                    {/* Bottom row */}
                    <div className="flex flex-col gap-0.5 w-full">
                      <p className="text-sm sm:text-base tracking-tight text-[#1F2937] leading-tight"
                        style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 700 }}>
                        {app.label}
                      </p>
                      <p className="text-[11px] sm:text-xs text-[#6B7280] leading-snug line-clamp-2"
                        style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 500 }}>
                        {app.desc}
                      </p>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </main>

      {/* Footer */}
      <footer className="w-full py-12 mt-12 border-t border-[#E5E7EB] flex flex-col items-center justify-center gap-3">
        <p className="text-4xl text-[#D1D5DB] tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}>Le Mas</p>
        <p className="text-sm text-[#6B7280]" style={{ fontFamily: "'Manrope', sans-serif" }}>
          Saint-Laurent-de-la-Salanque &middot; 04 68 38 06 98
        </p>
      </footer>
    </div>
  );
}
